@if (isTurnoverTax) {
    <div class="turnover-tax__tax-info">
        <span class="turnover-tax__tax-info-message">{{ taxInfoMessage }}</span>
        <span
            class="turnover-tax__tax-info-margin"
            [ngClass]="isTaxationInfoVisible ? 'theme-info-i' : 'theme-info'"
            (click)="displayTaxationInfo()"></span>
    </div>
}
@if (isTaxationInfoVisible) {
    <bs-digital-taxation-info [vm]="getTaxationViewModel" [(isVisible)]="isTaxationInfoVisible"></bs-digital-taxation-info>
}
